import { normalizeApiError } from 'shared/api'

type ToolResult = {
  content: Array<{ type: 'text'; text: string }>
  isError?: boolean
}

export const okResult = (data: unknown): ToolResult => ({
  content: [{ type: 'text', text: JSON.stringify(data) }],
})

export const errorResult = (e: unknown): ToolResult => ({
  content: [{ type: 'text', text: JSON.stringify({ error: normalizeApiError(e) }) }],
  isError: true,
})
